// src/App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import MainPage from "./pages/MainPage";
import AuthPage from './comps/AuthPage';
import MarketingHome from "./pages/public/MarketingHome"; // Ticketmaster-style home (live on /welcome)
import BusinessDirectory from "./pages/public/BusinessDirectory";
import PublicBusinessPage from "./pages/public/PublicBusinessPage";
import ManageReservation from "./pages/public/ManageReservation";
import MyReservations from "./pages/public/MyReservations";
import './style/css/main.css'
import managecookies from "./services/managecookies";
import { normalizeSession } from "./services/session";
import { I18nProvider } from "./i18n/I18nContext";

function App(props) {
    const [isAuthenticated, setIsAuthenticated] = useState(managecookies.getCookieVal('loginKey'));

    const handleLogin = async (res) => {
        // PHP login has no `user` object; enrich it with user:{id,role,name} so
        // the client's role-gated screens keep working under the unified backend.
        const data = normalizeSession(res.data);
        await managecookies.setCookie('authToken', data.token, 8) // בדיקת הרשאה
        await managecookies.setCookie('busiToken', data.business && data.business.length > 0 ? data.business[0].businessToken : null, 8) // בדיקת הרשאת עסק
        await managecookies.setCookie('userData', JSON.stringify(data), 8) // בדיקת שיוך התראה
        await managecookies.setCookie('loginKey', true, 8) // האם מחובר
        setIsAuthenticated(true);
    };

    return (
        <I18nProvider>
        <Router>
            <Routes>
                {/* Public (logged-out) pages — render for everyone, no app data exposed. */}
                <Route path="/welcome" element={<MarketingHome />} />
                <Route path="/discover" element={<BusinessDirectory />} />
                <Route path="/b/:slug" element={<PublicBusinessPage />} />
                {/* Customer self-manage a reservation via a secret token link (view/cancel). */}
                <Route path="/r/:token" element={<ManageReservation />} />
                {/* Customer self-service portal (phone + SMS-OTP, no account) — view/cancel own future reservations. */}
                <Route path="/my" element={<MyReservations />} />
                {/* Explicit login route: authenticated users get redirected into the app
                    (avoids a blank shell when the URL stays /login after login). */}
                <Route path="/login" element={isAuthenticated ? <Navigate to="/" replace /> : <AuthPage onLogin={handleLogin} />} />
                {/* Everything else stays behind the existing auth gate (unchanged). */}
                <Route path="/*" element={isAuthenticated ? <MainPage /> : <AuthPage onLogin={handleLogin} />} />
            </Routes>
        </Router>
        </I18nProvider>
    );
}

export default App;
